import { AuthGuard } from '@services/guards/auth-guard';
import { AuthInventoryGuard } from '@services/guards/auth-inventory-guard';
import { AuthPharmacyGuard } from '@services/guards/auth-pharmacy-guard';
import { AuthScorecardGuard } from '@services/guards/auth-scorecard-guard';
import { AuthWorkflowGuard } from '@services/guards/auth-workflow-guard';

export const GUARDS = {
  Auth: AuthGuard,
  Pharmacy: AuthPharmacyGuard,
  Scorecard: AuthScorecardGuard,
  Inventory: AuthInventoryGuard,
  Workflow: AuthWorkflowGuard,
} as const;

export type GuardType = keyof typeof GUARDS;
